import { Component } from "@angular/core";

@Component({
    selector: 'icon-send[ui-kit]',
    template: `
    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5 1.5L7.17 8.83M14.5 1.5l-4.67 12-2.66-5-5-2.66L14.5 1.5z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `,
})
export class IconSend {}
